import { HttpService } from '@Services/api/httpService.ts';
import { useBoundStore } from '@Store/useBoundStore.ts';
import {
  ObservabilityErrorSeverity,
  reportError,
} from '@Services/observability/initObservability.ts';
import { AppStateTypes } from '@Types/onboarding.types.ts';
import { handleLoginResponse } from '@Hooks/api/useLogin.ts';
import { showResumeApplicationModal } from '@Hooks/modalManager/showResumeApplicationModal.tsx';
import type { LoginResponse } from '@Hooks/api/useLogin.ts';

export const handleDirectLoginFlowInitialData = async (
  loginToken: string,
  customerId: string,
  continueMultiBusiness: boolean
) => {
  if (!loginToken && !continueMultiBusiness) {
    return;
  }
  const { setAppState } = useBoundStore.getState().onboardingSlice;
  const setAccessToken = useBoundStore.getState().setAccessToken;
  setAppState(AppStateTypes.LOADING);
  setAccessToken(loginToken);

  try {
    const response = await HttpService.post(`/v3/secureonboarding/user/${customerId}/login`);
    const loginResponse = response.data as LoginResponse;

    await handleLoginResponse({
      loginResponse,
      loginToken,
      onResume: () => {
        showResumeApplicationModal();
      },
    });
  } catch (e) {
    const errorToReport = {
      metadata: {
        name: 'handleDirectLoginFlowInitialData',
        message: JSON.stringify(e),
      },
      severity: ObservabilityErrorSeverity.ERROR,
    };
    reportError(errorToReport);
  } finally {
    setAppState(AppStateTypes.READY);
  }
};
